module.exports = __webpack_public_path__ + "logo-wix.a20b715ae0b06a4ee1f3fd4ad96773a7.svg";